import React, { Component, Fragment } from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';
const { RangePicker } = DatePicker;

class CustomRangePicker extends Component {
    render() {
        let { startDate = null, endDate = null, format = 'DD-MM-YYYY', onChange, style={}, disabledDate } = this.props;
        let range = null;
        if(startDate && endDate) {
            range= [moment(startDate, format), moment(endDate, format)];
        }
        return(
            <Fragment>
                <RangePicker
                    value={range}
                    style={style}
                    format={format}
                    onChange={onChange}
                    disabledDate={disabledDate}
                />
            </Fragment>
        );
    }
}

export default CustomRangePicker;